const e = {
  extends: "Pick4",
  logo: !0
};
export {
  e as default
};
